module.exports = __webpack_public_path__ + "img/carryall.460572bd.jpg";